import { Loader2 } from 'lucide-react';
import { ScriptAudioPanel } from '@/components/slides/ScriptAudioPanel';
import type { UnifiedSlide } from '@/types/gsapSlide';
import type { WorkspaceMode } from './VideoWorkspaceShell';

interface SceneAudioPanelProps {
  conversationId: string;
  /** The scene's own conversation (a video scene is a child conversation holding slide-001). */
  sceneConversationId: string;
  currentSlideId: string | null;
  currentSlideData: UnifiedSlide | null;
  mode?: WorkspaceMode;
}

// The scene changes at once on a switch, but its slide data (and DB slide id) only when the workspace's fetch lands;
// until then currentSlideData is another scene's. The workspace stamps loaded data with its scene (data.id = currentSlideId).
export function SceneAudioPanel({ conversationId, sceneConversationId, currentSlideId, currentSlideData, mode }: SceneAudioPanelProps) {
  if (currentSlideData && currentSlideData.id !== currentSlideId) {
    return (
      <div className="h-[200px] flex flex-col items-center justify-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <span className="text-sm text-muted-foreground">Loading audio data...</span>
      </div>
    );
  }
  const databaseSlideId = currentSlideData?.databaseId || '';
  if (!databaseSlideId || !sceneConversationId) {
    return (
      <div className="h-[200px] flex items-center justify-center studio-text-secondary text-sm">
        Select a slide to manage audio
      </div>
    );
  }
  return (
    <ScriptAudioPanel
      key={`audio-${conversationId}-${sceneConversationId}-${databaseSlideId}`}
      slideId={databaseSlideId}
      slideIdentifier={mode === 'video' ? 'slide-001' : (currentSlideId || '')}
      conversationId={sceneConversationId}
      parentConversationId={conversationId}
      initialScript={
        currentSlideData?.metadata?.script_text
        || currentSlideData?.gsapData?.metadata?.script_text
        || currentSlideData?.gsapData?.script_text
        || (currentSlideData as { script_text?: string } | null)?.script_text
        || ''
      }
      className="min-h-[200px] border-0"
    />
  );
}
